import request from '@/api/config/request'

const prex = "api/admin/nfse";

export function listNotasFiscaisAdmin(query = {}) {
    return request({
        url: `${prex}/lista`,
        method: 'get',
        params: query
    })
}